import { useCallback, useMemo } from "react";

export const useChapterNavigation = ({
  allChapters = [],
  currentIndex = -1,
  navigate,
  edition,
}) => {
  const hasPrev = currentIndex > 0 && Boolean(allChapters[currentIndex - 1]);
  const hasNext =
    currentIndex >= 0 &&
    currentIndex < allChapters.length - 1 &&
    Boolean(allChapters[currentIndex + 1]);

  const prevChapter = useMemo(
    () => (hasPrev ? allChapters[currentIndex - 1] : null),
    [allChapters, currentIndex, hasPrev]
  );

  const nextChapter = useMemo(
    () => (hasNext ? allChapters[currentIndex + 1] : null),
    [allChapters, currentIndex, hasNext]
  );

  const goToChapter = useCallback(
    (targetId) => {
      if (!targetId || !navigate || !edition?.chapterPath) return false;
      navigate(edition.chapterPath(targetId));
      return true;
    },
    [edition, navigate]
  );

  const goPrev = useCallback(() => {
    if (!prevChapter) return false;
    return goToChapter(prevChapter.id);
  }, [goToChapter, prevChapter]);

  const goNext = useCallback(() => {
    if (!nextChapter) return false;
    return goToChapter(nextChapter.id);
  }, [goToChapter, nextChapter]);

  return {
    hasPrev,
    hasNext,
    prevChapter,
    nextChapter,
    goPrev,
    goNext,
    goToChapter,
  };
};

export default useChapterNavigation;
